import { WorkspaceUrlParamsSettingsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/url_params/')({
  component: WorkspaceUrlParamsSettingsRoute,
});
